import OpeningDraft from './OpeningDraft'

export default OpeningDraft
